import React from 'react';
import { CtaButton } from './CtaButton';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaBlockProps {
  label?: string;
  note?: string;
  href?: string;
}
export function CtaBlock({
  label = '🚀 SÍ, QUIERO COMENZAR AHORA',
  note = 'Acceso Inmediato • Garantía de 7 Días',
  href = OFFER_ANCHOR
}: CtaBlockProps) {
  return <div className="mx-auto mt-4 max-w-md text-center" data-id="element-155" data-mp="3im2qm9piof65">
      <CtaButton href={href} data-id="element-156" data-mp="j5cssxqfxh32">{label}</CtaButton>
      {note && <p className="mt-1.5 text-xs font-medium text-marron/75" data-id="element-157" data-mp="j30agjgrt4ph">{note}</p>}
    </div>;
}